exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic-uploader .ant-upload-list-picture-card-container {\n  width: 120px !important;\n  height: 120px !important; }\n\n.full-width .ant-upload.ant-upload-select-picture-card,\n.full-width .ant-upload-list-picture-card .ant-upload-list-item,\n.full-width .ant-upload-list-picture-card-container {\n  width: 100% !important; }\n\n.photo-id-uploader .ant-upload-list-picture-card-container,\n.photo-id-uploader .ant-upload.ant-upload-select-picture-card,\n.photo-id-uploader .ant-upload-list-picture-card .ant-upload-list-item {\n  width: 300px !important;\n  height: 200px !important; }\n", ""]);

// exports
